const key = (principal: string) => `fusapp-work:console:organization:${encodeURIComponent(principal)}`

/** This is a UI preference only; callers must verify it against the current list. */
export function rememberedOrganization(principal: string): string | null {
  try { return localStorage.getItem(key(principal)) }
  catch { return null } // Blocked browser storage must leave manual selection usable.
}

export function rememberOrganization(principal: string, organizationId: string): boolean {
  try { localStorage.setItem(key(principal), organizationId); return true }
  catch { return false } // Selection remains committed in the URL even without persistence.
}
